import store from '@/store/index'
import apiConfig from '@/api/api'

const { api } = apiConfig()

const whiteLabelForCompany = {
  namespaced: true,

  state: () => ({
    allWhiteLabelCompanies: {
      data: [],
      totalRecords: 0
    }
  }),

  getters: {
    _allWhiteLabelCompanies: state => state.allWhiteLabelCompanies
  },

  mutations: {
    ALL_WHITE_LABEL_COMPANIES (state, { totalRecords, data }) {
      state.allWhiteLabelCompanies.totalRecords = totalRecords
      state.allWhiteLabelCompanies.data = data
    }
  },

  actions: {
    CreateWhiteLabelForCompany (_, { payload, config }) {
      return new Promise((resolve, reject) => {
        api.post('/WhiteLabelForCompany/CreateWhiteLabelForCompany', payload, config)
          .then(response => {
            if (response.responseCode === '04') {
              store.dispatch('users/UnauthorizedUser', config)
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              store.dispatch('users/UnauthorizedUser', config)
            } else {
              reject(error)
            }
          })
      })
    },
    ApproveWhiteLabelCompany (_, { whiteLabelForCompanyId, config }) {
      return new Promise((resolve, reject) => {
        api.post(`/WhiteLabelForCompany/ApproveWhiteLabelCompany?WhiteLabelForCompanyId=${whiteLabelForCompanyId}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              store.dispatch('users/UnauthorizedUser', config)
            } else {
              return response.data
            }
          })
          .then(data => {
            resolve(data)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              store.dispatch('users/UnauthorizedUser')
                .then(() => window.location.assign('/login'))
                .catch(error => {
                  reject(error)
                })
            } else {
              reject(error)
            }
          })
      })
    },
    DisapproveWhiteLabelCompany (_, { whiteLabelForCompanyId, comment, config }) {
      return new Promise((resolve, reject) => {
        api.post(`/WhiteLabelForCompany/DeactivateWhiteLabelCompany?WhiteLabelForCompanyId=${whiteLabelForCompanyId}&comment=${comment}`, null, config)
          .then(response => {
            if (response.responseCode === '04') {
              store.dispatch('users/UnauthorizedUser', config)
            } else {
              return response.data
            }
          })
          .then(data => {
            resolve(data)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              store.dispatch('users/UnauthorizedUser')
                .then(() => window.location.assign('/login'))
                .catch(error => {
                  reject(error)
                })
            } else {
              reject(error)
            }
          })
      })
    },

    GetAllWhiteLabelCompanies (_, { paginationParams, config }) {
      return new Promise((resolve, reject) => {
        api.get(`/WhiteLabelForCompany/GetAllWhiteLabelCompany?SearchValue=${paginationParams.searchValue}&PageNumber=${paginationParams.pageNumber}&PageSize=${paginationParams.pageSize}`, config)
          .then(response => {
            if (response.responseCode === '04') {
              store.dispatch('users/UnauthorizedUser', config)
            } else {
              return response.data
            }
          })
          .then(response => {
            resolve(response)
          })
          .catch(error => {
            if (error && error.response?.status === 401) {
              store.dispatch('users/UnauthorizedUser')
                .then(() => window.location.assign('/login'))
                .catch(error => {
                  reject(error)
                })
            } else {
              reject(error)
            }
          })
      })
    }
  }
}

export default whiteLabelForCompany
